/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientAgeLimit/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientAgeLimit({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/New/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/Content/EditAction/Content/Edit/Content/PatientAgeLimit"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesDependentAgeLimitValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.dependent_age_limit',
})
let constantData = '-'
let aggregateData = fromAggregate.any(insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesDependentAgeLimitValueData, constantData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="PatientAgeLimit.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-GB5Xy': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Patient age limit"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance.insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.dependent_age_limit"
 data="'-'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
 weight="medium"
 color={dtColorsBlack}
/>
</div>
{children}
</React.Fragment>)
}